/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CommentsResponse,
  CustomerFileOwnersOverView,
  DirectusUserResponse,
  DownloadDocumentResponse,
  ErrorResponseDto,
  ExportShipmentDocumentsParams,
  ExportShipmentsParams,
  FileManagersOverView,
  GetFileManagersParams,
  GetShipmentActivityOverviewParams,
  GetShipmentAdminsParams,
  GetShipmentCargoParams,
  GetShipmentCommentsParams,
  GetShipmentDocumentsOverviewParams,
  GetShipmentPricingParams,
  GetShipmentTrackingOverviewParams,
  GetShipmentsCountParams,
  GetShipmentsIdsParams,
  GetShipmentsOverviewParams,
  GetUsersForShipmentParams,
  ShipmentActivityOverviewPaginatedDto,
  ShipmentCargoResponse,
  ShipmentDetailsResponse,
  ShipmentDocumentsOverviewPaginatedDto,
  ShipmentIdsPaginatedDto,
  ShipmentOverviewPaginatedDto,
  ShipmentPricingOverView,
  ShipmentTrackingOverView,
  TotalCountDto,
  TrackingDetailsResponse,
  UpdateShipmentSubscriptionsBody,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Shipments<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Shipments
   * @name ExportShipmentDocuments
   * @summary export documents for a shipment
   * @request GET:/v1/shipments/{shipmentId}/documents/export
   * @response `200` `DownloadDocumentResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  exportShipmentDocuments = ({ shipmentId, ...query }: ExportShipmentDocumentsParams, params: RequestParams = {}) =>
    this.http.request<DownloadDocumentResponse, ErrorResponseDto>({
      path: `/v1/shipments/${shipmentId}/documents/export`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name ExportShipments
   * @summary Export all shipments
   * @request GET:/v1/shipments/export
   * @response `200` `DownloadDocumentResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  exportShipments = (query: ExportShipmentsParams, params: RequestParams = {}) =>
    this.http.request<DownloadDocumentResponse, ErrorResponseDto>({
      path: `/v1/shipments/export`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetFileManagers
   * @summary Get file managers
   * @request GET:/v1/shipments/file-managers
   * @response `200` `FileManagersOverView`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getFileManagers = (query: GetFileManagersParams, params: RequestParams = {}) =>
    this.http.request<FileManagersOverView, ErrorResponseDto>({
      path: `/v1/shipments/file-managers`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentActivityOverview
   * @summary Get shipment activity overview
   * @request GET:/v1/shipments/{id}/activity
   * @response `200` `ShipmentActivityOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentActivityOverview = ({ id, ...query }: GetShipmentActivityOverviewParams, params: RequestParams = {}) =>
    this.http.request<ShipmentActivityOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/shipments/${id}/activity`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentAdmins
   * @summary Get shipment admins
   * @request GET:/v1/shipments/shipment-admins
   * @response `200` `CustomerFileOwnersOverView`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentAdmins = (query: GetShipmentAdminsParams, params: RequestParams = {}) =>
    this.http.request<CustomerFileOwnersOverView, ErrorResponseDto>({
      path: `/v1/shipments/shipment-admins`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentCargo
   * @summary Get cargo for a shipment
   * @request GET:/v1/shipments/{id}/cargo
   * @response `200` `ShipmentCargoResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentCargo = ({ id, ...query }: GetShipmentCargoParams, params: RequestParams = {}) =>
    this.http.request<ShipmentCargoResponse, ErrorResponseDto>({
      path: `/v1/shipments/${id}/cargo`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentComments
   * @summary Get shipment comments
   * @request GET:/v1/shipments/{id}/comments
   * @response `200` `CommentsResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentComments = ({ id, ...query }: GetShipmentCommentsParams, params: RequestParams = {}) =>
    this.http.request<CommentsResponse, ErrorResponseDto>({
      path: `/v1/shipments/${id}/comments`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentDetails
   * @summary Get details for a shipment
   * @request GET:/v1/shipments/{id}
   * @response `200` `ShipmentDetailsResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentDetails = (id: string, params: RequestParams = {}) =>
    this.http.request<ShipmentDetailsResponse, ErrorResponseDto>({
      path: `/v1/shipments/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentDocumentsOverview
   * @summary Get all documents for a shipment
   * @request GET:/v1/shipments/{shipmentId}/documents
   * @response `200` `ShipmentDocumentsOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentDocumentsOverview = ({ shipmentId, ...query }: GetShipmentDocumentsOverviewParams, params: RequestParams = {}) =>
    this.http.request<ShipmentDocumentsOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/shipments/${shipmentId}/documents`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentPricing
   * @summary Get pricing for a shipment
   * @request GET:/v1/shipments/{id}/pricing
   * @response `200` `ShipmentPricingOverView`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentPricing = ({ id, ...query }: GetShipmentPricingParams, params: RequestParams = {}) =>
    this.http.request<ShipmentPricingOverView, ErrorResponseDto>({
      path: `/v1/shipments/${id}/pricing`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentsCount
   * @summary Get shipments count
   * @request GET:/v1/shipments/count
   * @response `200` `TotalCountDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentsCount = (query: GetShipmentsCountParams, params: RequestParams = {}) =>
    this.http.request<TotalCountDto, ErrorResponseDto>({
      path: `/v1/shipments/count`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentsIds
   * @summary Get all shipments ids
   * @request GET:/v1/shipments/ids
   * @response `200` `ShipmentIdsPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentsIds = (query: GetShipmentsIdsParams, params: RequestParams = {}) =>
    this.http.request<ShipmentIdsPaginatedDto, ErrorResponseDto>({
      path: `/v1/shipments/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentsOverview
   * @summary Get all shipments
   * @request GET:/v1/shipments
   * @response `200` `ShipmentOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentsOverview = (query: GetShipmentsOverviewParams, params: RequestParams = {}) =>
    this.http.request<ShipmentOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/shipments`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentTrackingDetails
   * @summary Get tracking details for a shipment
   * @request GET:/v1/shipments/{id}/tracking-details
   * @response `200` `TrackingDetailsResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentTrackingDetails = (id: string, params: RequestParams = {}) =>
    this.http.request<TrackingDetailsResponse, ErrorResponseDto>({
      path: `/v1/shipments/${id}/tracking-details`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetShipmentTrackingOverview
   * @summary Get tracking for a shipment
   * @request GET:/v1/shipments/{id}/tracking
   * @response `200` `ShipmentTrackingOverView`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getShipmentTrackingOverview = ({ id, ...query }: GetShipmentTrackingOverviewParams, params: RequestParams = {}) =>
    this.http.request<ShipmentTrackingOverView, ErrorResponseDto>({
      path: `/v1/shipments/${id}/tracking`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name GetUsersForShipment
   * @request GET:/v1/shipments/subscriptions/users
   * @response `200` `DirectusUserResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getUsersForShipment = (query: GetUsersForShipmentParams, params: RequestParams = {}) =>
    this.http.request<DirectusUserResponse, ErrorResponseDto>({
      path: `/v1/shipments/subscriptions/users`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Shipments
   * @name UpdateShipmentSubscriptions
   * @summary add or remove subscription to shipment
   * @request PATCH:/v1/shipments/{id}/subscriptions
   * @response `200` `void`
   * @response `204` `void`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  updateShipmentSubscriptions = (id: string, data: UpdateShipmentSubscriptionsBody, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponseDto>({
      path: `/v1/shipments/${id}/subscriptions`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
